import API from "@fetcher/fetcher";
import type Pagination from "@fetcher/models/IPagination";
import dayjs from "dayjs";
import type { IReview, IReviewAPI } from "./models/IReview";

const BASE_URL = "/reviews";

export default class ReviewAPI {
  static getReviews = async (page: number): Promise<Pagination<IReview>> => {
    return API.get<Pagination<IReviewAPI>>(`${BASE_URL}?page=${page}`).then(
      (res): Pagination<IReview> => ({
        ...res.data,
        data: res.data.data.map((r) => ({
          ...r,
          date: dayjs(r.date as unknown as string),
          type: "review",
        })),
      }),
    );
  };
}
